/**
 * In-app route to a single aggregator organization's detail page.
 */
export const getAggregatorDetailPath = (aggregatorId: number): string =>
  `/wfpManager/aggregators/${aggregatorId}`;

export const ADMINISTRATOR_SORT_OPTIONS = [
  {
    id: "aggregator",
    translationKey: "home.manager.overview.administratorsModal.columns.aggregator",
  },
  {
    id: "name",
    translationKey: "home.manager.overview.administratorsModal.columns.fullName",
  },
  {
    id: "email",
    translationKey: "home.manager.overview.administratorsModal.columns.email",
  },
  {
    id: "firstLogin",
    translationKey: "home.manager.overview.administratorsModal.columns.firstLogin",
  },
  {
    id: "lastSync",
    translationKey: "home.manager.overview.administratorsModal.columns.lastSync",
  },
  {
    id: "updatedOn",
    translationKey: "home.manager.overview.administratorsModal.columns.updatedOn",
  },
  {
    id: "appVersion",
    translationKey: "home.manager.overview.administratorsModal.columns.mobileAppVersion",
  },
  {
    id: "deviceModel",
    translationKey: "home.manager.overview.administratorsModal.columns.deviceModel",
  },
] as const;

/** Backend `version_status` values, defined once so no call site retypes the literals. */
export const VERSION_STATUS = {
  LATEST: "Latest",
  PREVIOUS: "Previous",
  OLD: "Old",
} as const;

export type VersionStatus = (typeof VERSION_STATUS)[keyof typeof VERSION_STATUS];

interface VersionStatusMeta {
  /** Tailwind background class for the status dot. */
  dotClassName: string;
  translationKey: string;
}

/**
 * Visual metadata for each backend `version_status` value. The dot colors are the
 * exact design-system tokens requested for the mobile-version indicator. Keyed by
 * `string` because the lookup takes whatever the backend sent; callers guard for
 * an unknown status.
 */
export const VERSION_STATUS_META: Record<string, VersionStatusMeta> = {
  [VERSION_STATUS.LATEST]: {
    dotClassName: "bg-success-600",
    translationKey: "home.manager.overview.administratorsModal.versionStatus.latest",
  },
  [VERSION_STATUS.PREVIOUS]: {
    dotClassName: "bg-warning-300",
    translationKey: "home.manager.overview.administratorsModal.versionStatus.previous",
  },
  [VERSION_STATUS.OLD]: {
    dotClassName: "bg-danger-600",
    translationKey: "home.manager.overview.administratorsModal.versionStatus.old",
  },
};
